export default "__VITE_ASSET__tx79crI0__"